<template>
  <div>
    <h1 class="text-h5 pb-2">
      Daten zur zusätzlichen Abnahmestelle
      <span v-if="count > 1">{{ current + 1 }} von {{ count }}</span>
    </h1>
    <p v-if="count > 1" class="pb-6">
      Bitte füllen Sie die Daten für jede der {{ count }} zusätzlichen
      Abnahmestellen aus.
    </p>
    <div v-else class="pb-8"></div>
    <!-- One sub form per additional supply point. v-window slides between them
         so the switch is visible even though the step above stays the same. -->
    <v-window v-model="current" touchless>
      <v-window-item
        v-for="(form, index) in forms"
        :key="`${index}-abnahmestelle`"
        eager>
        <v-form :ref="`${index}-form`" class="px-1">
          <h3>STROMDATEN</h3>
          <v-row>
            <v-col>
              <v-text-field
                v-model="form.energyData.currentSupplier.value"
                label="Bisheriger Stromlieferant (zusätzliche Abnahmestelle)*"
                :rules="[v => !!v || 'Bitte ausfüllen!']"
                required></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="form.energyData.customerNumberOld.value"
                label="Kundennummer der zusätzlichen Abnahmestelle"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.energyData.meteringNumber.value"
                label="Zählernummer*"
                :rules="[v => !!v || 'Bitte ausfüllen!']"
                required></v-text-field>
            </v-col>
          </v-row>

          <h3 class="pt-5">ADRESSE DER ZUSÄTZLICHEN ABNAHMESTELLE</h3>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.shareSupplyAddress.street.value"
                label="Straße*"
                :rules="[v => !!v || 'Bitte ausfüllen!']"
                required></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.shareSupplyAddress.number.value"
                label="Hausnummer*"
                :rules="[v => !!v || 'Bitte ausfüllen!']"
                required></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.shareSupplyAddress.postalcode.value"
                label="Postleitzahl*"
                :rules="[v => !!v || 'Bitte ausfüllen!']"
                required></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.shareSupplyAddress.region.value"
                label="Ort*"
                :rules="[v => !!v || 'Bitte ausfüllen!']"
                required></v-text-field>
            </v-col>
          </v-row>

          <h3 class="pt-5">WECHSELGRUND*</h3>
          <v-row>
            <v-col>
              <v-radio-group
                v-model="changeReasons[index].value"
                column
                class="mt-1"
                mandatory>
                <v-radio
                  v-for="(item, itemIndex) in changeReasonItems"
                  :label="item.name"
                  :value="item.value"
                  :key="`${itemIndex}-change-reason`"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="form.changeReason.date.value"
                :label="
                  changeReasonItem(index).requiredDate
                    ? `Datum auswählen*`
                    : `Datum auswählen`
                "
                :min="MIN_DATE"
                :rules="
                  changeReasonItem(index).requiredDate
                    ? [v => !!v || 'Bitte ausfüllen!', minDateRule]
                    : [minDateRule]
                "
                type="date"></v-text-field>
            </v-col>
          </v-row>
          <p style="font-size: 8pt; color: grey">*Pflichtangaben</p>
        </v-form>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { MIN_DATE, minDateRule } from "../../helper";
export default {
  data() {
    return {
      MIN_DATE,
      current: 0,
      changeReasons: [],
      changeReasonItems: [
        {
          name: "Lieferantenwechsel zum nächstmöglichen Zeitpunkt",
          value: 1,
          requiredDate: false,
        },
        { name: "Lieferantenwechsel zum", value: 2, requiredDate: true },
        { name: "Einzug/Umzug zum", value: 3, requiredDate: true },
        {
          name: "Vertrag durch Kunden bereits gekündigt zum",
          value: 4,
          requiredDate: true,
        },
        { name: "Neubau des Hauses", value: 5, requiredDate: true },
      ],
      menu: false,
      forms: [],
    };
  },
  computed: {
    ...mapState({
      selectedTarifAndOptions: state => {
        return state.selectedTarifAndOptions ?? null;
      },
    }),
    count() {
      return this.forms.length;
    },
    checkPageVisibility() {
      if (!this.selectedTarifAndOptions.options) {
        this.$emit("ErrorNoTarifOptions");
        return false;
      }
      if (
        this.selectedTarifAndOptions &&
        !this.selectedTarifAndOptions.options.cloudToShare
      ) {
        this.$emit("removePage");
        return false;
      }
      return true;
    },
  },
  methods: {
    minDateRule,
    emptyForm(index, count) {
      let suffix = count > 1 ? ` ${index + 1}` : "";
      return {
        text: `Objektdaten der zusätzlichen Abnahmestelle${suffix}`,
        energyData: {
          text: "Stromdaten",
          currentSupplier: { text: "Bisheriger Stromlieferant", value: "" },
          customerNumberOld: {
            text: "Kundennummer beim bisherigen Stromanbieter",
            value: "",
          },
          meteringNumber: { text: "Zählernummer", value: "" },
        },
        shareSupplyAddress: {
          text: "Adresse der zusätzlichen Abnahmestelle",
          street: { text: "Straße", value: "" },
          number: { text: "Hausnummer", value: "" },
          postalcode: { text: "Postleitzahl", value: "" },
          region: { text: "Ort", value: "" },
        },
        changeReason: {
          text: "Wechselgrund",
          reason: { text: "Wechselgrund", value: "" },
          date: { text: "Datum", value: "" },
        },
      };
    },
    changeReasonItem(index) {
      return (
        this.changeReasonItems[this.changeReasons[index].value - 1] ?? {
          name: "",
          requiredDate: false,
        }
      );
    },
    formRef(index) {
      return this.$refs[`${index}-form`][0];
    },
    // The checkout stepper advances only when validate() returns true, so the
    // sub forms for the additional supply points stay on the same step.
    validate() {
      if (!this.formRef(this.current).validate()) return false;
      if (this.current < this.count - 1) {
        this.current++;
        return false;
      }
      return true;
    },
    // Called by the checkout before it steps back. Returning true means this
    // component handled the navigation itself.
    back() {
      if (this.current == 0) return false;
      this.current--;
      return true;
    },
    reset() {
      this.forms.forEach((form, index) => this.formRef(index).reset());
    },
    resetValidation() {
      this.forms.forEach((form, index) =>
        this.formRef(index).resetValidation()
      );
    },
    parseData() {
      this.forms.forEach((form, index) => {
        form.changeReason.reason.value = this.changeReasonItem(index).name;
      });
    },
    saveData(id) {
      this.parseData();
      let data = {
        id: id,
        section: "formSupplyCloudToShare",
        data: this.forms,
        enabled: true,
      };
      this.$store.commit("setCheckoutData", data);
    },
  },
  created() {
    let count = 1;
    if (
      this.selectedTarifAndOptions &&
      this.selectedTarifAndOptions.options &&
      this.selectedTarifAndOptions.options.cloudToShareAmount > 1
    ) {
      count = parseInt(
        this.selectedTarifAndOptions.options.cloudToShareAmount,
        10
      );
    }
    for (let index = 0; index < count; index++) {
      this.forms.push(this.emptyForm(index, count));
      this.changeReasons.push({ value: 1 });
    }
  },
  mounted() {
    this.resetValidation();
    this.checkPageVisibility;
  },
};
</script>

<style></style>
